/* tslint:disable:forin */
/* tslint:disable:no-for-in */

export abstract class Formattable {

    [propName: string]: any;
    private formattedObj : any;   

    constructor() {        
    }

    protected abstract getFormatters(): any;

    public formatted() : any {
        if (this.formattedObj == null) {
            var obj: any = {};

            /* loop over all properties */
            for (const p in this) {                
                obj[p] = (): any => {
                    if (<any>this[p] instanceof Formattable && this[p] != null) {
                        return (<any>this[p]).formatted();
                    } else {
                        return Formattable.formatNull(this[p]);
                    }
                };
            }

            /* loop over all formatters*/
            var formatters = this.getFormatters();
            for (const p in formatters) {
                obj[p] = () => { return Formattable.formatNull(formatters[p]()); };
            }

            this.formattedObj = obj;
        }    

        return this.formattedObj;       
    }

    public static formatNull(value: any): any {
        return (value === null || value === undefined) ? "" : value;
    }
       
}